import React from "react";

const NotFound = () => {
  return <div>404: Not Found!</div>;
};

export default NotFound;
